import React from 'react'
import { ColorCircleProps } from './ColorCircle.types'
import styles from './ColorCircle.module.scss'
import cl from 'classnames'

const ColorCircleComponent = (props: ColorCircleProps) => {
  const {
    className,
    style,
    color
  } = props

  return (
    <span
      className={cl(styles.colorCircle, className)}
      style={{ backgroundColor: color, ...style }}
    />
  )
}

const ColorCircle = ColorCircleComponent
export { ColorCircle }
